import i18n from 'i18n'

export const ASSET_TABS = {
    TAB_MY_LIBRARY: 'TAB_MY_LIBRARY',
    TAB_UNSPLASH_LIBRARY: 'TAB_UNSPLASH_LIBRARY',
    TAB_PIXABAY: 'TAB_PIXABAY',
    TAB_GIPHY: 'TAB_GIPHY',
    TAB_AUDIO: 'TAB_AUDIO',
    TAB_FREE_AUDIO: 'TAB_FREE_AUDIO',
}

export const SIZE_IMAGES = {
    SMALL: 'SMALL',
    TINY: 'TINY',
    ORIGINAL: 'ORIGINAL',
    NORMAL: 'NORMAL',
    NORMAL2X: 'NORMAL2X',
}

export const UPLOAD_STATUS = {
    prepare: 'prepare',
    ok: 'ok',
    error: 'error',
}

export const ASSET_TABS_INFO = {
    [ASSET_TABS.TAB_MY_LIBRARY]: {
        title: i18n.t('My library'),
    },
    [ASSET_TABS.TAB_UNSPLASH_LIBRARY]: {
        title: i18n.t('Free photos'),
        note: i18n.t('by Unsplash'),
    },
    [ASSET_TABS.TAB_PIXABAY]: {
        title: i18n.t('Free illustrations'),
        note: i18n.t('by Pixabay'),
    },
    [ASSET_TABS.TAB_GIPHY]: {
        title: i18n.t("Free GIF's"),
        note: i18n.t('by Giphy'),
    },
    [ASSET_TABS.TAB_AUDIO]: {
        title: i18n.t('Audio library'),
    },
    [ASSET_TABS.TAB_FREE_AUDIO]: {
        title: i18n.t('Free Interacty library'),
    },
}

export const ASSET_CONTENT_TYPE = {
    audio: 'audio',
    images: 'images',
}

export const IMAGE_TYPES = {
    JPEG: 'image/jpeg',
    PNG: 'image/png',
    GIF: 'image/gif',
}
export const AUDIO_TYPES = {
    MPEG: 'audio/mpeg',
    WAV: 'audio/wav',
    OGG: 'audio/ogg',
}

export const SUPPORT_IMAGE_TYPES = new Set([IMAGE_TYPES.JPEG, IMAGE_TYPES.PNG, IMAGE_TYPES.GIF])
export const SUPPORT_AUDIO_TYPES = new Set([AUDIO_TYPES.MPEG, AUDIO_TYPES.WAV, AUDIO_TYPES.OGG])
export const MAX_IMAGE_FILE_SIZE = 12_582_912
export const MAX_AUDIO_FILE_SIZE = 5_242_880
